<template>
  <div class="p-3 bg-white">
    <shared-add-message-template :categories="categoryOptions" @storeMessageTemplateSuccess="storeMessageTemplateSuccess"></shared-add-message-template>
    <div class="text-center">
      <vs-button id="addTemplateButton" class="m-2" color="primary" type="filled" @click.prevent="storeMessageTemplate">{{ $t('save') }}</vs-button>
      <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancel">{{ $t('cancel') }}</vs-button>
    </div>
  </div>
</template>

<script>
import Template from '@/models/Template'
import SharedAddMessageTemplate from '@/views/Shared/Messages/Templates/Add'
import { EventBus } from '@/../eventbus'

export default {
  name: 'Window.Messages.Templates.Add',
  components: {
    SharedAddMessageTemplate
  },
  data () {
    return {
      categoryOptions: [],
      templateId: ''
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    async initData () {
      try {
        const response = await Template.all()
        this.categoryOptions = response.data.meta.options.categories
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }
    },
    storeMessageTemplate () {
      EventBus.$emit('storeMessageTemplate')
    },
    storeMessageTemplateSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_message_templates_table')
      window.close()
    },
    cancel () {
      this.$windowOpenerHelper.notifyOpener('reload_message_templates_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
